// extracted by mini-css-extract-plugin
export var container = "_4g-0";
export var disabled = "_4g-4";
export var fullWidth = "_4g-3";
export var lined = "_4g-1";
export var selected = "_4g-5";
export var tab = "_4g-2";